import { apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  requestQueue: [],
}

const createRequestQueueSlice = (set, get) => ({
  ...initialState,
  enqueueRequest: (request) => set(() => ({ requestQueue: [...get().requestQueue.filter(r => r.id !== request.id), request] })),
  dequeueRequest: (requestId) => set(() => ({ requestQueue: get().requestQueue.filter(r => r.id !== requestId) })),
  updateRequestStatus: (requestId, status) => set(() => ({ requestQueue: get().requestQueue.map(r => r.id === requestId ? { ...r, status } : r) })),
  markRequestSuccess: (requestId) => {
    get().updateRequestStatus(requestId, 'success')
    setTimeout(() => {
      get().dequeueRequest(requestId)
    }, 2000)
  },
  retryRequest: (requestId) => {
    const request = get().requestQueue.find(r => r.id === requestId)
    get()[request.action](...request.arguments)
  },
})

export default createRequestQueueSlice